import { render, staticRenderFns } from "./DialogSubject.vue?vue&type=template&id=720955ac&"
import script from "./DialogSubject.vue?vue&type=script&lang=js&"
export * from "./DialogSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports